import Multiselect from 'multiselect-react-dropdown';
import React, {useState,useEffect} from 'react'
import './ModalWide.css'
import { getCurrentUser } from '../utils/auth'

const buildProtocolOption = (item) => {
    const protocolId = Number(item?.protocol?.protocol_id ?? item?.protocol_id ?? item?.id ?? 0);
    const protocolName = String(item?.protocol?.name ?? item?.name ?? item?.description ?? '').trim();
    const protocolTypeDescription = String(
        item?.protocol?.protocol_type?.description
        ?? item?.protocol?.protocol_type_description
        ?? item?.protocol_type?.description
        ?? item?.protocol_type_description
        ?? ''
    ).trim();

    return {
        description: protocolName,
        dropdownLabel: protocolTypeDescription ? `${protocolName} (${protocolTypeDescription})` : protocolName,
        selectionKey: `${protocolName}::${protocolId}`,
        id: protocolId,
    };
};

const ModalCustomerEdit = ({closeModal, onSubmit, customerEdit, allCustomerTypes, allProtocols, allSportTeams, isNewCustomer, isReadOnly = false}) => {
    const tokenPayload = getCurrentUser() || {};
    const tokenUserType = tokenPayload.user_type;
    const isReadOnlyMode = !!isReadOnly;
    const [customerInfo, setCustomerInfo] = useState(customerEdit);
    const [currentSportTeam, setCurrentSportTeam] = useState();
    const [disabledSport, setDisabledSport] = useState(true);
    const [originaCustomerProtocols, setOriginalCustomerProtocols] = useState([]);
    const [customerProtocols, setCustomerProtocols] = useState([]);
    const [removedCustomerProtocols, setRemovedCustomerProtocols] = useState([]);
    const [originalOfflineProtocols, setOriginalOfflineProtocols] = useState([]);
    const [offlineProtocols, setOfflineProtocols] = useState([]);
    const [removedOfflineProtocols, setRemovedOfflineProtocols] = useState([]);
    const [isCustomer, setIsCustomer] = useState(false);
    const [isLoadingModalData, setIsLoadingModalData] = useState(true);
    const [errors, setErrors] = useState("");

    useEffect(() => {
        let isMounted = true;

        const requestHeaders = {
            'machine':'2',
            'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
        };

        const fetchJson = async (url) => {
            const response = await fetch(url,
                {
                    method: 'GET',
                    headers: requestHeaders,
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            return response.json();
        };

        const initializeModalData = async () => {
            setIsLoadingModalData(true);
            try {
                if (tokenUserType < 3) {
                    setIsCustomer(true);
                }

                if ((customerEdit?.description ?? '').toLowerCase() === 'sport') {
                    setDisabledSport(false);
                }

                if (isNewCustomer) {
                    return;
                }

                const [sportTeamData, customerProtocolData, offlineProtocolResult] = await Promise.all([
                    fetchJson(process.env.REACT_APP_API_URL_BASE + '/sport_team_customers/customer/' + customerEdit.id),
                    fetchJson(process.env.REACT_APP_API_URL_BASE + '/customer_protocols/customer_list/' + customerEdit.id),
                    fetchJson(process.env.REACT_APP_API_URL_BASE + '/customer_protocol_offline/customer_list/' + customerEdit.id)
                        .catch((error) => {
                            console.error(error);
                            return [];
                        }),
                ]);

                if (!isMounted) {
                    return;
                }

                setCurrentSportTeam(sportTeamData?.[0]);

                const protocols = (Array.isArray(customerProtocolData) ? customerProtocolData : []).map((item) => buildProtocolOption(item));
                setCustomerProtocols(protocols);
                setOriginalCustomerProtocols(protocols);

                const hydratedOfflineProtocols = (Array.isArray(offlineProtocolResult) ? offlineProtocolResult : []).map((item) => buildProtocolOption(item));
                setOfflineProtocols(hydratedOfflineProtocols);
                setOriginalOfflineProtocols(hydratedOfflineProtocols);
            } catch (error) {
                console.error(error);
            } finally {
                if (isMounted) {
                    setIsLoadingModalData(false);
                }
            }
        };

        initializeModalData();

        return () => {
            isMounted = false;
        };
    }, [customerEdit, isNewCustomer, tokenUserType]);

    const apiPatchCustomerInfo = async (customerId, patchCustomerInfo) => {
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/customers/customer/' + customerId,
            {
                method: 'PATCH',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
                body: JSON.stringify(patchCustomerInfo),
            });
            if (!response.ok) {
                console.log('Failed to update the resource');
                console.log(response);
            }
    }

    async function updateCustomerProtocols(customerId) {
        const updatedCustomerProtocols = customerProtocols.map(protocol => ({
            ...protocol,
            customer: customerId
        }));
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/customer_protocols/array/' + customerId + '/',
            {
                method: 'POST',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
                body: JSON.stringify(updatedCustomerProtocols),
            });
        if (!response.ok) {
            console.log('Failed to update the resource');
            console.log(response);
        }
    }

    const updateOfflineProtocols = async (customerId) => {
        const updatedOfflineProtocols = offlineProtocols.map(protocol => ({
            ...protocol,
            customer: customerId
        }));
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/customer_protocol_offline/array/' + customerId + '/',
            {
                method: 'POST',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
                body: JSON.stringify(updatedOfflineProtocols),
            });
        if (!response.ok) {
            console.log('Failed to update the offline protocol resources');
            console.log(response);
        }
    }

    const apiPostNewCustomer = async (patchCustomerInfo) => {
        console.log(patchCustomerInfo)
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/customers/',
            {
                method: 'POST',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
                body: JSON.stringify(patchCustomerInfo),
            });
        const data = await response.json();
        if (customerProtocols && customerProtocols.length > 0) {
            await updateCustomerProtocols(data.customer_id);
        }
        if (offlineProtocols && offlineProtocols.length > 0) {
            await updateOfflineProtocols(data.customer_id);
        }
        if (response.ok) {
            console.log('Customer Added Successfully')
        }
        else {
            console.log('Failed to update the resource');
            console.log(response);
        }
        return true;
    }

    const apiPostSportTeamCustomer = async (customer_id, sport_team_id) => {
        const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/sport_team_customers/',
            {
                method: 'POST',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    'customer': customer_id,
                    'sport_team': sport_team_id
                    }
                ),
            });
        await response.json();
        if (response.ok) {
            console.log('Customer added to sport team successfully')
        }
        else {
            console.log('Failed to update the resource');
            console.log(response);
        }
        return true;
    }

    const validateForm = async () => {
        console.log(customerProtocols)
        console.log(removedCustomerProtocols)
        console.log(offlineProtocols)
        console.log(removedOfflineProtocols)
        if (customerInfo.customer_name && customerInfo.contact_name){
            setErrors("")
            const patchCustomerInfo = {...customerInfo}
            const customerId = patchCustomerInfo.id
            let keysToRemove = ['customer_id', 'created_on',]
            keysToRemove.map((e) => delete patchCustomerInfo[e])
            setCustomerInfo(patchCustomerInfo)
            if (isNewCustomer) {
                await apiPostNewCustomer(patchCustomerInfo)
            }
            else {
                await apiPatchCustomerInfo(customerId, patchCustomerInfo)
                // console.log('customer: ' + customerId + '  new sport: ' + patchCustomerInfo.sport_team_id);
                // console.log(currentSportTeam)
                if ((patchCustomerInfo?.sport_team_id ?? null) !== (currentSportTeam?.sport_team ?? null)){
                    await apiPostSportTeamCustomer(customerId, patchCustomerInfo.sport_team_id)
                }
                if (customerProtocols || removedCustomerProtocols.length > 0) {
                    await updateCustomerProtocols(customerId);
                }
                if (offlineProtocols.length > 0 || removedOfflineProtocols.length > 0) {
                    await updateOfflineProtocols(customerId);
                }
            }
            // TODO: if used to be sport and is no longer then delete record in sport_team_customer
            // TODO: if still sport and it has changed then update sport_team_customer - add API post and remove old entry for this customer
            // TODO: if is now sport and used to be other, then post new sport_team_customer

            return true;
        }
        else {
            let errorFields = [];
            for(const [key, value] of Object.entries(customerInfo)) {
                if(!value){
                    errorFields.push(key);
                }
            }
            setErrors(errorFields.join(", "));
            return false;
        }
    }

    const handleTypeChange = (e) => {
        const selectedTypeId = Number(e.target.value);
        const selectedType = allCustomerTypes.find((customerType) => {
            const typeId = customerType.id ?? customerType.customer_type_id;
            return Number(typeId) === selectedTypeId;
        });

        if (!selectedType) {
            return;
        }

        setCustomerInfo({
            ...customerInfo,
            'description': selectedType.description,
            'customer_type_id': selectedTypeId,
            'customer_type': selectedTypeId
        })
        if (selectedType.description.toLowerCase() === "sport") {
            setDisabledSport(false)
        }
        else {
            setDisabledSport(true)
        }
    }

    const handleSportTeamChange = (e) => {
        const selectedSportTeamId = Number(e.target.value);
        const selectedSportTeam = allSportTeams.find((sportTeam) => Number(sportTeam.id) === selectedSportTeamId);

        setCustomerInfo({
            ...customerInfo,
            'team_name': selectedSportTeam?.description ?? '',
            'sport_team_id': selectedSportTeamId
        })
        // setCurrentSportTeam({
        //     ...currentSportTeam,
        //     ''
        // })
        //fetchLogo(allSportTeams[e.target.selectedIndex].id)
    }

    const handleChange = (e) => {
        setCustomerInfo({
            ...customerInfo,
            [e.target.name]: e.target.value
        })
    }

    const handleSelect = (selectedList, selectedItem) => {
        setCustomerProtocols(selectedList);
        var isInRemovedProtocols = removedCustomerProtocols.find(protocol => protocol.id === selectedItem.id);
        if (isInRemovedProtocols) {
            // If the selected item is in the removed protocols, remove it from the removed list
            setRemovedCustomerProtocols(removedCustomerProtocols.filter(protocol => protocol.id !== selectedItem.id));
        }
    }

    const handleRemove = (selectedList, removedItem) => {
        setCustomerProtocols(selectedList);
        var removedProtocol = originaCustomerProtocols.find(protocol => protocol.id === removedItem.id);
        if (removedProtocol) {
            setRemovedCustomerProtocols([...removedCustomerProtocols, removedProtocol]);
        }
    }

    const handleCheckChange = (e) => {
        setCustomerInfo({
            ...customerInfo,
            [e.target.name]: e.target.checked
        })
    }

    const handleOfflineProtocolSelect = (selectedList, selectedItem) => {
        setOfflineProtocols(selectedList);
        const isInRemovedOfflineProtocols = removedOfflineProtocols.find((protocol) => protocol.id === selectedItem.id);
        if (isInRemovedOfflineProtocols) {
            setRemovedOfflineProtocols(removedOfflineProtocols.filter((protocol) => protocol.id !== selectedItem.id));
        }
    }

    const handleOfflineProtocolRemove = (selectedList, removedItem) => {
        setOfflineProtocols(selectedList);
        const removedProtocol = originalOfflineProtocols.find((protocol) => protocol.id === removedItem.id);
        if (removedProtocol) {
            setRemovedOfflineProtocols([...removedOfflineProtocols, removedProtocol]);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        var isValidated = await validateForm()
        if (!isValidated) return;

        onSubmit(customerInfo);
        closeModal();
    }

    const handleCancel = (e) => {
        e.preventDefault();
        closeModal();
    }

    return (
    <div className='modal-container'>
      <div className='modal-edit'>
        <button className='modal-close-btn' onClick={handleCancel} aria-label='Close customer details modal'>X</button>
        <form>
            {isLoadingModalData ? (
                <div className='client-skeleton-grid'>
                    <section className='client-card'>
                        <div className='skeleton-line skeleton-title'></div>
                        <div className='skeleton-line skeleton-id-row'></div>
                        <div className='skeleton-input-row'>
                            <div className='skeleton-line skeleton-input'></div>
                            <div className='skeleton-line skeleton-input'></div>
                        </div>
                        <div className='skeleton-line skeleton-input'></div>
                    </section>
                    <section className='client-card'>
                        <div className='skeleton-line skeleton-title'></div>
                        <div className='skeleton-input-row'>
                            <div className='skeleton-line skeleton-input'></div>
                            <div className='skeleton-line skeleton-input'></div>
                        </div>
                        <div className='skeleton-line skeleton-input tall'></div>
                    </section>
                </div>
            ) : (
                <div className='client-card-grid'>
                    <section className='client-card'>
                        <div className='client-card-header'>
                            <h3>Customer Info</h3>
                        </div>
                        <div className='client-fields-grid two-col'>
                            <div className='wide id-row'>
                                <label htmlFor='customer_id' className='id-value'>ID: {isNewCustomer ? 'New Customer' : (customerInfo.id ?? '')}</label>
                                <div className='id-active-toggle'>
                                    <input id='is_active' name="is_active" type="checkbox" value={customerInfo.is_active} onChange={handleCheckChange} checked={customerInfo.is_active} disabled={isReadOnlyMode}/>
                                    <label htmlFor='is_active'>Active</label>
                                </div>
                            </div>
                            <div className='form-group'>
                                <label htmlFor='customer_name'>Customer Name*</label>
                                <input name="customer_name" value={customerInfo.customer_name} onChange={handleChange} readOnly={isReadOnlyMode}/>
                            </div>
                            <div className='form-group'>
                                <label htmlFor='contact_name'>Customer Contact*</label>
                                <input name="contact_name" value={customerInfo.contact_name} onChange={handleChange} readOnly={isReadOnlyMode}/>
                            </div>
                            <div className='form-group wide'>
                                <label htmlFor='contact_email'>Contact Email</label>
                                <input name="contact_email" value={customerInfo.contact_email} onChange={handleChange} readOnly={isReadOnlyMode}/>
                            </div>
                        </div>
                    </section>

                    <section className='client-card'>
                        <h3>Customer Settings</h3>
                        <div className='client-fields-grid two-col'>
                            <div className='form-group'>
                                <label htmlFor='customer_type'>Type</label>
                                <select name="description" value={customerInfo.customer_type_id ?? customerInfo.customer_type ?? ''} onChange={handleTypeChange} disabled={isReadOnlyMode}>
                                    {(allCustomerTypes ?? []).map((customer_type, index) => (
                                        <option key={customer_type.id ?? index} value={customer_type.id ?? customer_type.customer_type_id}>
                                            {customer_type.description}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {!disabledSport &&
                            <div className='form-group'>
                                <label htmlFor='sport_team'>Sport Team</label>
                                <select name="sport_team" value={customerInfo.sport_team_id ?? ''} onChange={handleSportTeamChange} disabled={disabledSport || isReadOnlyMode}>
                                    {(allSportTeams ?? []).map((sport_team, index) => (
                                        <option key={sport_team.id ?? index} value={sport_team.id}>
                                            {sport_team.description}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            }

                            <div className='form-group toggle-field'>
                                <input id='is_authorized' name="is_authorized" type="checkbox" value={customerInfo.is_authorized} onChange={handleCheckChange} checked={customerInfo.is_authorized} disabled={isReadOnlyMode}/>
                                <label htmlFor='is_authorized'>Authorized</label>
                            </div>

                            {!isCustomer &&
                            <div className='form-group wide'>
                                <label htmlFor='assigned_protocol'>Assigned Protocols</label>
                                <Multiselect
                                    displayValue="selectionKey"
                                    onKeyPressFn={function noRefCheck(){}}
                                    onRemove={handleRemove}
                                    onSearch={function noRefCheck(){}}
                                    onSelect={handleSelect}
                                    options={allProtocols ?? []}
                                    optionValueDecorator={(value, option) => option?.dropdownLabel ?? option?.description ?? value}
                                    ref={function noRefCheck(){}}
                                    selectedValueDecorator={(value, option) => option?.description ?? value}
                                    selectedValues={customerProtocols}
                                    className="customer-protocol-select"
                                    disable={isReadOnlyMode}
                                />
                            </div>
                            }
                        </div>
                    </section>

                    {!isCustomer &&
                    <section className='client-card'>
                        <div className='client-fields-grid'>
                            <div className='form-group wide'>
                                <label htmlFor='offline_protocol'>Offline Protocols</label>
                                <Multiselect
                                    displayValue="selectionKey"
                                    onKeyPressFn={function noRefCheck(){}}
                                    onRemove={handleOfflineProtocolRemove}
                                    onSearch={function noRefCheck(){}}
                                    onSelect={handleOfflineProtocolSelect}
                                    options={allProtocols ?? []}
                                    optionValueDecorator={(value, option) => option?.dropdownLabel ?? option?.description ?? value}
                                    ref={function noRefCheck(){}}
                                    selectedValueDecorator={(value, option) => option?.description ?? value}
                                    selectedValues={offlineProtocols}
                                    className="customer-protocol-select"
                                    disable={isReadOnlyMode}
                                />
                            </div>
                        </div>
                    </section>
                    }
                </div>
            )}

            {!isLoadingModalData && !isReadOnlyMode && errors && <div className='error'>{`Please include: ${errors}`}</div>}
            {!isLoadingModalData && (
                <div className='client-actions-row'>
                    <button type='button' className='btn btn-cancel' onClick={handleCancel}>{isReadOnlyMode ? 'Close' : 'Cancel'}</button>
                    {!isReadOnlyMode && <button type='submit' className='btn' onClick={handleSubmit}>Save</button>}
                </div>
            )}
        </form>
      </div>

    </div>
  )

}

export default ModalCustomerEdit


